<template>
  <div class="nuttrema-footer">
    <div class="nuttrema-footer__left">
      <slot name="left">
        <div class="nuttrema-footer__logo"></div>
        <div class="nuttrema-footer__company">
          <p v-html="_markdown.renderInline($t('label.copyright_footer'))"></p>
          <p v-html="_markdown.renderInline($t('label.powered_by_footer'))"></p>
        </div>
      </slot>
    </div>
    <div class="nuttrema-footer__right">
      <slot name="right">
        <div class="nuttrema-footer__action">
          <nuttrema-change-language></nuttrema-change-language>
          <nuttrema-change-theme></nuttrema-change-theme>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import NuttremaChangeTheme from 'components/ui/button/nuttrema-change-theme';
import NuttremaChangeLanguage from 'components/ui/button/nuttrema-change-language';

export default {
  name: 'nuttrema-footer',
  components: {
    NuttremaChangeTheme,
    NuttremaChangeLanguage,
  },
};
</script>

<style lang="scss" scoped>
.nuttrema-footer {
  display: flex;
  flex-shrink: 0;
  min-height: 3em;
  margin-top: 1em;
  flex-basis: 100%;
  padding: 2em 2.5em;
  justify-content: space-between;
  border-top: 1px solid rgba(0, 0, 0, 0.05);

  .nuttrema-footer__left {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  .nuttrema-footer__logo {
    display: flex;
    width: 5em;
    height: 3em;
    background-size: auto 75%;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url('~assets/images/dc-logo-small-white.svg');
  }

  .nuttrema-footer__company {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    p {
      text-align: left;
      line-height: 1.25;
      color: #fff;
    }
  }

  .nuttrema-footer__action {
    display: flex;
    > * {
      margin-right: 1em;
      &:last-child {
        margin-right: 0;
      }
    }

    /deep/ .el-dropdown-link {
      color: #fff;
    }
  }

  .nuttrema-footer__right {
    display: flex;
    align-items: center;
  }

  .nuttrema-theme-professional-topography & {
    .nuttrema-footer__logo {
      background-image: url('~assets/images/dc-logo-small-gray.svg');
    }
    .nuttrema-footer__company {
      p {
        color: #475669;
      }
    }
    .nuttrema-footer__action {
      /deep/ .el-dropdown-link {
        color: #475669;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-footer.vue